import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { AnimatedLogo } from './AnimatedLogo';

const Wrap = styled.footer`
  width: 100%;
  margin-top: auto;
  padding: ${({ theme }) => theme.spacing.lg} ${({ theme }) => theme.spacing.xl};
  border-top: 1px solid ${({ theme }) => theme.colors.border};
  background-color: ${({ theme }) => theme.colors.surface};
`;

const Inner = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  gap: ${({ theme }) => theme.spacing.lg};
  align-items: start;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    grid-template-columns: 1fr 1fr;
    gap: ${({ theme }) => theme.spacing.md};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    grid-template-columns: 1fr;
    gap: ${({ theme }) => theme.spacing.md};
  }
`;

const BrandCol = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
`;

const Tagline = styled.p`
  font-size: ${({ theme }) => theme.fontSize.xs};
  color: ${({ theme }) => theme.colors.textSecondary};
  line-height: 1.5;
  max-width: 260px;
`;

const ColTitle = styled.h3`
  font-size: 11px;
  font-weight: ${({ theme }) => theme.fontWeight.semibold};
  color: ${({ theme }) => theme.colors.text};
  text-transform: uppercase;
  letter-spacing: 0.08em;
  margin-bottom: ${({ theme }) => theme.spacing.sm};
`;

const LinkList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const linkStyles = `
  font-size: 13px;
  color: #64748B;
  text-decoration: none;
  transition: color 0.15s ease;
  &:hover { color: #3B82F6; }
`;

const FooterLink = styled(Link)`${linkStyles}`;

const Bottom = styled.div`
  max-width: 1100px;
  margin: ${({ theme }) => theme.spacing.md} auto 0;
  padding-top: ${({ theme }) => theme.spacing.sm};
  border-top: 1px solid ${({ theme }) => theme.colors.border};
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.md};

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    flex-direction: column;
    text-align: center;
    gap: 4px;
  }
`;

const BottomText = styled.p`
  font-size: 11px;
  color: ${({ theme }) => theme.colors.textMuted};
`;

const PoweredLink = styled.a`
  color: ${({ theme }) => theme.colors.textSecondary};
  font-weight: ${({ theme }) => theme.fontWeight.semibold};
  text-decoration: none;
  transition: color 0.15s ease;
  &:hover { color: #3B82F6; }
`;

export function Footer() {
  return (
    <Wrap>
      <Inner>
        <BrandCol>
          <AnimatedLogo variant="v1" tone="auto" height={24} />
          <Tagline>
            Your website turned into weeks of social-media content.
          </Tagline>
        </BrandCol>

        <div>
          <ColTitle>Product</ColTitle>
          <LinkList>
            <li><FooterLink to="/features">Features</FooterLink></li>
            <li><FooterLink to="/about">About Us</FooterLink></li>
            <li><FooterLink to="/changelog">What's New</FooterLink></li>
          </LinkList>
        </div>

        <div>
          <ColTitle>Legal</ColTitle>
          <LinkList>
            <li><FooterLink to="/privacy">Privacy Policy</FooterLink></li>
            <li><FooterLink to="/terms">Terms of Service</FooterLink></li>
          </LinkList>
        </div>
      </Inner>

      <Bottom>
        <BottomText>
          © {new Date().getFullYear()} Coopen SMM. All rights reserved.
        </BottomText>
        <BottomText>
          Powered by{' '}
          <PoweredLink href="https://coopenstudio.com" target="_blank" rel="noreferrer">CoopenStudio</PoweredLink>
          {' '}&amp;{' '}
          <PoweredLink href="https://clearfuturecs.com" target="_blank" rel="noreferrer">ClearFutureCS</PoweredLink>
        </BottomText>
      </Bottom>
    </Wrap>
  );
}
